module.exports = __webpack_public_path__ + "static/media/marquart-logo.800a19e8.svg";